import { BaseProduct } from './BaseProduct';

class SimpleProduct extends BaseProduct {
  static buildCharacteristic(data) {
    return {
      index: data.index,
      text: data.text,
    };
  }

  constructor(params) {
    super(params);
    this.characteristics = (params.characteristics || [])
      .map(SimpleProduct.buildCharacteristic)
      .sort((a, b) => (a.index - b.index > 0 ? 1 : -1));
    this.productType = params.productType;
    this.subMenu = params.subMenu;
    this.serviceProduct = params.serviceProduct ? new SimpleProduct(params.serviceProduct) : null;
  }
}

export { SimpleProduct };



// WEBPACK FOOTER //
// ./src/models/SimpleProduct.js